import { getLoggedInUser } from '@/plugins/authentication/lib/Authentication';

export enum Scope {
  CLIENTS_ACCESS_ALL = 'clients:access:all',
  COMMISSIONNEMENT_ACCESS_ALL = 'commissionnement:access:all',
  CONTRACTUEL_ACCESS_ALL = 'contractuel:access:all',
  DIGITAL_INSURE = 'digital-insure',
  DISTRIBUTEURS_READ_OWN = 'distributeurs:read:own',
  OFFRES_ACCESS_ALL = 'offres:access:all',
  PILOTAGE_ACCESS_ALL = 'pilotage:access:all',
  SANTE_SELECT = 'sante-select',
  UTILISATEUR_PREFERENCES_READ_ALL = 'utilisateurs:preferences:read:all',
  UTILISATEUR_PREFERENCES_READ_OWN = 'utilisateurs:preferences:read:own',
  UTILISATEUR_PREFERENCES_WRITE_ALL = 'utilisateurs:preferences:write:all',
  UTILISATEUR_PREFERENCES_WRITE_OWN = 'utilisateurs:preferences:write:own',
  UTILISATEURS_READ_ALL = 'utilisateurs:read:all',
  UTILISATEURS_WRITE_ALL = 'utilisateurs:write:all',
}

export async function hasScope(scope: string): Promise<boolean> {
  const {
    distributeur: { scopes },
  } = await getLoggedInUser();

  return scopes.includes(scope);
}
